import styled from "styled-components";
import {VERTICAL_SPACING_PX} from "../../css-global-constants";

export const VerticalSeparatorBox = styled.div`
    height: ${VERTICAL_SPACING_PX};
`
